import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "contact-reveal" }
const _hoisted_2 = ["aria-disabled", "aria-label", "aria-controls"]
const _hoisted_3 = ["id", "aria-busy"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "error-component"
}

import { computed, ref } from 'vue';
  import { useFetch } from '@utils/fetch-service';
  import { HttpError } from '@utils/models/HttpError';
  import type { IFindSrfConsultantPageTranslations } from '../../interfaces/IFindSrfConsultantPageTranslations';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactReveal',
  props: {
    contactId: {},
    contactName: {},
    contactType: {},
    translations: {}
  },
  setup(__props: any) {

  const props = __props;

  const { post, loading } = useFetch('/findsrfconsultantapp/reveal');
  const value = ref('');
  const errorMessage = ref('');
  const label = computed(() => props.contactType === 'email' ? props.translations.showEmail : props.translations.showPhone);
  const resultId = computed(() => `contact-reveal-${props.contactId}-${props.contactType}`);
  const href = computed(() => props.contactType === 'email'
    ? `mailto:${encodeURIComponent(value.value).replace(/%40/g, '@')}`
    : `tel:${value.value.replace(/[^+\d]/g, '')}`);

  async function reveal() {
    if (loading.value || value.value) {
      return;
    }

    errorMessage.value = '';
    try {
      const response = await post<{ value: string }>({
        contactId: props.contactId,
        contactType: props.contactType,
      }, { cache: 'no-store' });
      if (typeof response.value !== 'string' || !response.value.trim()) {
        throw new Error('Missing contact value');
      }

      value.value = response.value;
    } catch (error) {
      if (error instanceof HttpError && error.status === 404) {
        errorMessage.value = props.translations.contactUnavailable;
      } else {
        errorMessage.value = props.translations.revealError;
      }
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!value.value && !_unref(loading))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "contact-reveal__button link",
          "aria-disabled": _unref(loading),
          "aria-label": `${label.value}: ${__props.contactName}`,
          "aria-controls": resultId.value,
          onClick: reveal
        }, _toDisplayString(label.value), 9 /* TEXT, PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", {
      id: resultId.value,
      class: "contact-reveal__result",
      "aria-live": "polite",
      "aria-atomic": "true",
      "aria-busy": _unref(loading)
    }, [
      (value.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: href.value
          }, _toDisplayString(value.value), 9 /* TEXT, PROPS */, _hoisted_4))
        : (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.translations.revealingContact), 1 /* TEXT */))
          : (errorMessage.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(errorMessage.value), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
    ], 8 /* PROPS */, _hoisted_3)
  ]))
}
}

})